import { render, staticRenderFns } from "./multipleChoice.vue?vue&type=template&id=1651223a&scoped=true"
import script from "./multipleChoice.vue?vue&type=script&lang=js"
export * from "./multipleChoice.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice.vue?vue&type=style&index=0&id=1651223a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1651223a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1651223a')) {
      api.createRecord('1651223a', component.options)
    } else {
      api.reload('1651223a', component.options)
    }
    module.hot.accept("./multipleChoice.vue?vue&type=template&id=1651223a&scoped=true", function () {
      api.rerender('1651223a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/testquestion-manage/multipleChoice.vue"
export default component.exports